import { configureStore } from "@reduxjs/toolkit";
import appReducer, { playlistApi } from "./appSlice";

export default configureStore({
  reducer: {
    app: appReducer,
    [playlistApi.reducerPath]: playlistApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(playlistApi.middleware),
});
